import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { InitAPIStatus } from '../store/action';
import { GetStoreRole ,GetStoreDetailRole} from '../const/constant';
import moment from 'moment';

function PrivateRoute(props) {
  const {
    Component, 
    loginState, 
    sendAPIStatusState, 
    auth,
    path,
    InitAPIStatus,
  } = props;
  let useragent = navigator.userAgent;
  const role = GetStoreRole(localStorage.getItem('current_store_id'));
  useragent = useragent.toLowerCase();
  const detailrole = GetStoreDetailRole(localStorage.getItem('current_store_id')) ;

  // 調班頁面轉址
  // if (path.indexOf('adjustStaffShiftDetail/:day') !== -1) {
  //   if (useragent.indexOf('iphone') !== -1 || useragent.indexOf('ipad') !== -1 || useragent.indexOf('ipod') !== -1 || useragent.indexOf('android') !== -1) {
  //     return <Redirect to="/pageNotice" />;
  //   }
  // }

  // 若傳送的API出問題
  if (sendAPIStatusState === 500) {
    InitAPIStatus();
    return <Redirect to="/errorPage" />;
  }
  // 若權限不足
  if (auth !== 'all') {
    console.log('props : '+props.path)
    console.log('detailrole : '+detailrole)
    if((props.path === '/signinsalarymanagement'  && localStorage.getItem('username') === '0933089198') || (props.path === '/rentallList' && detailrole==='17')|| (props.path === '/rentallList' && detailrole==='19')){
      console.log('有權限')
    }else if (!auth.some(item => item === Number(role)) ) {
      InitAPIStatus();
      return <Redirect to="/" />;
    }
  }

  return (
    <Route
      {...props}
      render={_props => (
        loginState.isLogin === true
          ? <Component {..._props} />
          : (
            <Redirect to={{
              pathname: '/Login',
              state: { from: _props.location },
            }}
            />
          )
      )}
    />
  );
}

const mapStateToProps = store => ({
  loginState: store.loginState,
  sendAPIStatusState: store.SendAPIStatusState,
});

export default connect(mapStateToProps, { InitAPIStatus })(PrivateRoute);
